import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import AudioPlayer from "@/components/AudioPlayer";

type AudioMessageProps = {
  audio: { url: string; transcription?: string };
  isCustomer?: boolean;
};

const AudioMessage = ({ audio, isCustomer }: AudioMessageProps) => {
  const [showTranscription, setShowTranscription] = useState(false);

  return (
    <div>
      <AudioPlayer audioUrl={audio.url} isCustomer={isCustomer} />
      {audio.transcription && (
        <>
          <button
            onClick={() => setShowTranscription(!showTranscription)}
            className="mt-1.5 flex items-center gap-1 text-xs text-gray-500 hover:text-gray-700"
          >
            {showTranscription ? (
              <ChevronUp className="size-3" />
            ) : (
              <ChevronDown className="size-3" />
            )}
            {showTranscription ? "Ocultar transcripción" : "Ver transcripción"}
          </button>
          {showTranscription && (
            <p className="mt-1.5 text-sm leading-relaxed text-gray-600 italic">
              {audio.transcription}
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default AudioMessage;
